import { render, staticRenderFns } from "./ContactFormComponent.vue?vue&type=template&id=2d8497ee&"
import script from "./ContactFormComponent.vue?vue&type=script&lang=ts&"
export * from "./ContactFormComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/admin/heropage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8497ee')) {
      api.createRecord('2d8497ee', component.options)
    } else {
      api.reload('2d8497ee', component.options)
    }
    module.hot.accept("./ContactFormComponent.vue?vue&type=template&id=2d8497ee&", function () {
      api.rerender('2d8497ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactFormComponent.vue"
export default component.exports